<template>
  <div class="detail">
    <el-card class="min_height_crad400">
      <el-page-header @back="goBack" :content="tabName"></el-page-header>
      <div class="tab min_height_crad400">
        <el-tabs>
          <el-tab-pane>
            <span slot="label">
              <i class="el-icon-date"></i>
              {{ tabName }}
            </span>
            <div class="main">
              <div class="searchBox">
                <div class="searchList mainItem" v-if="this.$route.query.tabNum == 3">
                  <el-select v-model="status" placeholder="请选择" @change="optChange">
                    <el-option v-for="item in options" :key="item.status" :label="item.label" :value="item.status"></el-option>
                  </el-select>
                </div>
                <div class="block searchTime mainItem">
                  <el-date-picker v-model="time" type="datetimerange" align="center" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="optChange"></el-date-picker>
                </div>
                <div class="searchInput mainItem">
                  <el-input v-model="name" placeholder="请输入姓名" @keyup.native="nameChange"></el-input>
                </div>
                <div class="searchInput mainItem">
                  <el-button class="searchInput_btn" type="primary" @click="search">搜索</el-button>
                </div>
              </div>
              <div class="content">
                <el-table :data="list_data" style="width: 100%" @sort-change="sortChange">
                  <el-table-column align="center" label="患者姓名">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" placement="top">
                        <p>姓名: {{ scope.row.name }}</p>
                        <div slot="reference" class="name-wrapper">
                          <!--<el-tag size="medium">{{ scope.row.name }}</el-tag>-->
                          <p>{{ scope.row.name }}</p>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="性别">
                    <template slot-scope="scope">
                      <div class="name-wrapper">
                        {{ scope.row.gender_text }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="年龄">
                    <template slot-scope="scope">
                      <div class="name-wrapper">{{ scope.row.age }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="科室">
                    <template slot-scope="scope">
                      <div class="name-wrapper">{{ scope.row.department }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="检查时间">
                    <template slot-scope="scope">
                      <!--<el-tag type="success">{{statusList[scope.row.status]}}</el-tag>-->
                      <i class="el-icon-time"></i>
                      <span style="margin-left: 10px">{{
                        scope.row.created
                      }}</span>
                    </template>
                  </el-table-column>
                  <!--<el-table-column label="过敏史" width="300">-->
                  <!--<template slot-scope="scope">-->
                  <!--<el-tag type="success">{{statusList[scope.row.status]}}</el-tag>-->
                  <!--</template>-->
                  <!--</el-table-column>-->
                  <!--<el-table-column label="症状" width="300">-->
                  <!--<template slot-scope="scope">-->
                  <!--<el-tag type="success">{{statusList[scope.row.status]}}</el-tag>-->
                  <!--</template>-->
                  <!--</el-table-column>-->
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" v-show="scope.row.is_eye_department == 1" @click="handleCheck(scope.$index, scope.row)">阅片</el-button>
                      <el-button size="mini" type="danger" @click="handleDetail(scope.$index, scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- <div class="pageWarpper" v-show="list_data != ''">
        <el-pagination @current-change="currentPageChange" :page-size="pageList.pageSize" :current-page="pageList.pageNum" layout="total, prev, pager, next" :total="pageList.total"></el-pagination>
      </div> -->
    </el-card>
  </div>
</template>

<script>
import util from "@/utils";
import { getOrderList } from "@/api/index.js";
export default {
  data () {
    return {
      list_data: [],
      tableData: [],
      pageList: {
        pageSize: 10,
        pageNum: 1,
      },
      statusList: ["待确认", "已确认", "已拒绝"],
      tabName: "",
      options: [
        {
          status: "-1",
          label: "全部",
        },
        {
          status: "0",
          label: "待确认",
        },
        {
          status: "1",
          label: "已确认",
        },
        {
          status: "2",
          label: "已拒绝",
        },
      ],
      status: "-1",
      time: [],
      name: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
    };
  },
  methods: {
    search () {
      this.readyPatientList();
    },
    //分页
    currentPageChange (page) {
      this.pageList.pageNum = page;
      this.readyPatientList();
    },
    //返回上一层
    goBack () {
      const that = this;
      let tabNum = this.$route.query.tabNum;
      if (tabNum == 2) {
        that.$router.push({
          path: "/index/work/patients",
        });
      } else {
        that.$router.push({
          path: "/index/work/appointment",
        });
      }
    },
    //阅片
    handleCheck (index, row) {
      let query = {
        sickId: row.sick_id,
        sickImId: row.im_accid,
        casesId: row.cases_id,
        orderId: row.id,
        from: "workDetail",
        tabNum: this.$route.query.tabNum,
      };
      if (row.is_hava_report == 1) {
        this.$router.push({
          path: "/index/user/reportManage",
          query: { tabNum: this.$route.query.tabNum },
        });
      } else {
        this.$router.push({
          path: "/index/work/slice",
          query,
        });
      }
    },
    //查看详情
    handleDetail (index, row) {
      let query = {
        tabNum: this.$route.query.tabNum,
        fromType: "workdetail",
        sessionId: "p2p-" + row.im_accid,
      };
      if (row.id) {
        this.$router.push({
          path: "/index/work/chart",
          query,
        });
      } else {
        this.$message({
          type: "error",
          message: "当前会话已删除",
        });
      }
    },
    sortChange (column, prop, order) {
    },
    //下拉列表选项改变
    optChange (val) {
      var tabNum = this.$route.query.tabNum;
      if (tabNum == "2") {
        this.readyPatientList();
      } else if (tabNum == "3") {
        this.readyApointList();
      }
    },
    //关键字输入框离开事件
    nameChange () {
    },
    /**
     * 初次获取我的患者列表
     */
    async readyPatientList () {
      try {
        const that = this;
        let params = {
          status: that.status === "-1" ? "" : that.status,
          startTime: that.time[0],
          endTime: that.time[1],
          pageNo: that.pageList.pageNo,
          pageSize: that.pageList.pageSize,
          name: that.name,
        };
        let res = await getOrderList(params);
        if (res.success) {
          this.list_data = res.result.records;
          this.pageList = res.result;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
      }
    },
    //预约列表
    readyApointList () {
      var that = this;
      let params = {
        status: that.status == "-1" ? "" : that.status,
        start_time: that.time.length > 0 ? that.time[0].getTime() : "",
        end_time: that.time.length > 0 ? that.time[1].getTime() : "",
        name: that.name,
        pageNum: that.pageList.pageNum,
        pageSize: that.pageList.pageSize,
      };
      getOrderList(params).then((res) => {
        if (res.code === 1) {
          const result = res;
          this.list_data = result.data.data;
        } else {
          this.$message({
            showClose: true,
            message: result.msg,
            type: "error",
          });
        }
      });
    },
  },
  mounted () {
    var tabList = ["最近咨询", "我的患者", "我的预约"];
    var tabNum = this.$route.query.tabNum;
    this.tabName = tabList[tabNum - 1];
    if (tabNum == "2") {
      this.readyPatientList();
    } else if (tabNum == "3") {
      this.readyApointList();
    }
  },
};
</script>

<style lang="scss" scoped>
.detail {
  padding: 20px;

  .mainItem {
    float: left;
  }

  .mainItem:nth-child(2) {
    margin: 0 20px;
  }

  .mainItem:nth-child(3) {
    width: 20%;
  }
  .pageWarpper {
    text-align: center;
  }
  .searchInput_btn {
    margin-left: 80px;
    height: 40px;
    width: 100px;
  }
}
</style>
